import {useEffect} from 'react'
import {useCrmIdentity} from './lib/crmIdentity'
import {purgeCrmResourceDrafts} from './lib/crmSync'
import {useCrmResource} from './lib/useCrmResource'
import {getCompanyClaimQueue,purgeProspectDrafts} from './lib/prospecting'

// This observer renders no data. It uses the visible queue's exact resource key,
// reader and permission lifecycle, so that mounting the queue shares its pending
// read/result rather than submitting another request or maintaining a cache.
export function CompanyQueueWarmup({isReady}:{isReady:()=>boolean}){
  const {userId,workspaceId}=useCrmIdentity()
  const queue=useCrmResource('company-claim-queue',(_previous,context)=>getCompanyClaimQueue(context),false,null,isReady)
  useEffect(()=>{
    if(queue.denied){
      purgeProspectDrafts(JSON.stringify([userId,workspaceId]))
      purgeCrmResourceDrafts('company-claim-queue',{userId,workspaceId})
    }
  },[queue.denied,userId,workspaceId])
  return null
}
